import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import { GroupForm } from './forms/GroupForm';
import { createGroup } from '../../../../../../../api/admin/groups';
import { NOTIFICATION_CREATE_ADMIN_GROUP, NOTIFICATION_ADD_ADMIN_GROUP } from '../../../../../../../config/notifications';
import { onEnter, onExit } from "../../../../../../../config/customModalFunctions";

function CreateGroupModal(props) {
  const { showModal, closeModal } = props;

  const submit = (values) => {
    return createGroup({
      data: {
        name: values.groupName,
      },
      notificationId: values.action === 'save' ? NOTIFICATION_CREATE_ADMIN_GROUP : NOTIFICATION_ADD_ADMIN_GROUP
    }).then(
      response => {
        if (response && response.data) {
          props.actionCallback(1);
          return true;
        }
      }
    ).finally(() => {
      if (values.action === 'save') {
        props.closeModal();
      }
      return false;
    });
  }

  return (
    <Modal
      isOpen={ showModal }
      toggle={ closeModal }
      onEnter={ onEnter }
      onExit={ onExit }
      centered
    >
      <ModalHeader toggle={ closeModal }>
        <FormattedMessage id="components.pages.admin.groups.modals.create.title" />
      </ModalHeader>
      <ModalBody>
        <GroupForm
          toggle={ closeModal }
          onSubmit={ submit }
        />
      </ModalBody>
    </Modal>
  );
}

export { CreateGroupModal };
